import { Svg } from 'assets';

export const socialMediaIcons = [
    // {
    //     Icon: Svg.FacebookFooter,
    //     path: 'https://www.facebook.com/',
    // },
    //
    {
        Icon: Svg.InstagramFooter,
        path: 'https://www.instagram.com/therapylake/',
    },
    {
        Icon: Svg.LinkedinFooter,
        path: 'https://www.linkedin.com/company/therapylake/about/',
    },
    // {
    //     Icon: Svg.YoutubeFooter,
    //     path: 'https://www.youtube.com/',
    // },

    {
        Icon: Svg.TwitterFooter,
        path: 'https://x.com/i/flow/login?redirect_after_login=%2Ftherapylakeaba',
    },
];

export const firstBlock = [
    {
        title: 'Practice Management',
        path: '/practice',
    },

    {
        title: 'Data Collection',
        path: '/data-collection',
    },
];

export const secondBlock = [
    {
        title: 'about us',
        path: '/about-us',
    },

    {
        title: 'contact us',
        path: '/contact-us',
    },
];

export const thirdBlock = [
    {
        title: 'Blog',
        path:  "http://blog.therapylake.com/",
        target:'_blank'
    },
];




